import Navigation from "../../../../components/header";
import { Container } from "@mui/material";

const MonthlySummaryByMaterialReport = () => {
	return (
		<>
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<h1 className="report-header">Monthly Summary By Material Report</h1>
				<iframe title="HWIOnline_MonthlySummaryByMaterial_DEV" width="1140" height="700" src="https://app.powerbi.com/reportEmbed?reportId=05326627-7717-480c-99ff-d3012865206a&autoAuth=true&ctid=3d903043-2b47-4eb6-ba60-a27fe7950ef2" frameBorder="1"></iframe>
			</Container>

		</>
	);
};

export default MonthlySummaryByMaterialReport;